export const GROUP_TYPE = {
	MANUAL: 'manual',
	SYNCED: 'synced',
	SUB_GROUP_SYNCED: 'sub_synced',
};
export const WHAT_TO_SYNC_TYPES = {
	ONLY_USERS: 'only_users',
	USERS_AND_GROUPS: 'users_and_groups',
	SPECIFIC_GROUPS_AND_ONLY_THEIR_USERS: 'only_specific_subgroups',
};

export const SYNC_USERS_ACTION_TYPE = {
	INVITE_NEW: 'invite_new',
	SYNC_EXISTING_PLY_USERS: 'existing_users',
	INVITE_NEW_WITHOUT_SENDING_NOTIFICATION: 'invite_new_without_sending_notification',
};

export const SYNC_GROUP_ON_DELETE_TYPE = {
	DELETE: 'delete',
	TURN_MANUAL: 'turn_to_manual_group',
};

export const GROUP_USE_PERMISSION_TYPE = {
	EVERYONE: 'everyone',
	ADMINS_AND_MANAGERS: 'admins_and_managers',
};

export const GROUP_PERMITTED_USES = {
	ALL: 'all',
	PREFERENCES: 'usage_preferences',
};
